export default ({ test, children }) => (test ? children : null);



// WEBPACK FOOTER //
// ./src/components/support/if/index.jsx